// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"064e17c7","453":"4f03f355","796":"3509f6fd"}[chunkId] + ".chunk.js";
};